function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 8.067c0 2.246-1.634 4.067-3.65 4.067s-3.65-1.821-3.65-4.067C8.45 5.82 10.084 4 12.1 4s3.65 1.82 3.65 4.067zM19.4 18.234c0 2.47-3.716 1.627-7.3 1.627-3.584 0-7.3.844-7.3-1.627 0-2.47 3.716-4.473 7.3-4.473 3.584 0 7.3 2.003 7.3 4.473z",
  fill: "#fff"
});

var SvgUserWhite = function SvgUserWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgUserWhite;